<template>
  <v-app-bar
    :absolute="!fix"
    :bottom="!fix"
    :class="{ 'fixed-nav-top-position': fix }"
    :fixed="fix"
    color="white"
    height="76"
    style="z-index: unset;"
  >
    <v-row
      align="center"
      align-content-sm="center"
      align-content-lg="start"
      no-gutters
      style="max-width: 100%"
    >
      <v-col v-show="fix" sm="2" md="3" lg="4" :class="{'align-center d-flex' : fix}">
        <v-row align="center" no-gutters>
          <v-col md="3" lg="3" xl="2" class="d-sm-none d-md-flex">
            <StorefrontImage size="nav" />
          </v-col>
          <v-col
            sm="6"
            md="9"
            lg="9"
            xl="10"
          >
            <h1
            class="
              e2e-navigation-storename
              font-weight-medium
              storename-font-size-res
              text-truncate text-uppercase
            "
            >
              {{ wait(storeInfo, "name") }}
            </h1>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex overflow-auto hidden-scrollbar">
        <template v-if="websiteFormat === 'all_items'">
          <NavChip v-for="(chip, index) in navTabs" :key="index" :chip="chip" />
        </template>
        <TemplateNav v-else/>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import NavChip from "@/components/Navigation/NavChip.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";
import TemplateNav from '@/components/Navigation/TemplateNav.vue';

export default {
  name: "Nav",
  components: {
    TemplateNav,
    NavChip,
    StorefrontImage,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
      websiteFormat: (state) => state.store.info.store_info.customization?.website.style.website_format ?? 'all_items',
    }),
  },
  methods: {
    wait(object, prop) {
      return object ? object[prop] : "";
    },
  },
  props: { fix: Boolean, navTabs: Array },
};
</script>

<style scoped>
.fixed-nav-top-position {
  top: 76px;
}

.storename-font-size-res {
  font-size: var(--font-size-xs);
}
@media (min-width: 960px) {
  .storename-font-size-res {
    font-size: var(--font-size-md);
  }
}

.hidden-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
